import { Flex, Table, Tbody, Text } from '@chakra-ui/react'
import type { OrganizationUnit } from 'BrokerTsLib/src/dtos'
import { getOrganizationUnitTypeName } from 'BrokerTsLib/src/enums'

import { Address, EmailAddress, Phone, UserLink } from '@/components'
import { TableSection } from '@/components/Section/TableSection'
import { TableSectionRow } from '@/components/Section/TableSectionRow'
import { Building, Group, Info, TextUnorderedList, User } from '@/icons'
import { formatDateTime } from '@/utils/formatDate'

export const OrganizationInfo = ({
  organization,
}: {
  organization?: OrganizationUnit
}) => (
  <TableSection
    sectionTitle={
      <Flex justifyContent="space-between" alignItems="center">
        <Text>Informace</Text>
        {organization?.dateCreated && !organization?.dateModified && (
          <Text fontSize="sm" fontWeight="thin">
            Vytvořeno: {formatDateTime(organization?.dateCreated)}{' '}
            {organization.createdBy && (
              <UserLink
                userId={organization.createdById}
                name={organization.createdBy}
              />
            )}
          </Text>
        )}
        {organization?.dateModified && (
          <Text fontSize="sm" fontWeight="thin">
            Upraveno: {formatDateTime(organization?.dateModified)}{' '}
            {organization.modifiedBy && (
              <UserLink
                userId={organization.modifiedById}
                name={organization.modifiedBy}
              />
            )}
          </Text>
        )}
      </Flex>
    }
  >
    <Table variant={'simple'} fontSize={'md'}>
      <Tbody>
        <TableSectionRow icon={<Info />} title="ID">
          {organization?.id}
        </TableSectionRow>
        {organization?.description && (
          <TableSectionRow icon={<TextUnorderedList />} title="Popis">
            {organization?.description}
          </TableSectionRow>
        )}
        <TableSectionRow icon={<Group />} title="Typ organizace">
          {getOrganizationUnitTypeName(organization?.type)}
        </TableSectionRow>
        <TableSectionRow icon={<Building />} title="Adresa">
          <Address
            city={organization?.addressCity ?? ''}
            street={organization?.addressStreet ?? ''}
            streetNumber={organization?.addressStreetNumber ?? ''}
            postCode={organization?.addressPostCode ?? ''}
          />
        </TableSectionRow>
        {organization?.ico && (
          <TableSectionRow icon={<></>} title="IČO">
            {organization?.ico}
          </TableSectionRow>
        )}
        {organization?.nationalBankLicenseCode && (
          <TableSectionRow icon={<></>} title="Kód ČNB">
            {organization?.nationalBankLicenseCode}
          </TableSectionRow>
        )}
        <TableSectionRow icon={<User />} title="Kontaktní osoba">
          <Flex flexDir="column" gap={1} pb={1}>
            <Text my={1}>{organization?.contactName}</Text>
            {organization?.phone && (
              <Phone number={organization?.phone} phoneIcon />
            )}
            {organization?.mobilePhone && (
              <Phone number={organization?.mobilePhone} mobilePhoneIcon />
            )}
            {organization?.email && (
              <EmailAddress showIcon email={organization.email} />
            )}
          </Flex>
        </TableSectionRow>
      </Tbody>
    </Table>
  </TableSection>
)
